import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@vds/date-pickers';

import './appointment.css';

import { getFormattedDate } from '../../../utils/CalenderUtils';
import { isMobile } from '../../common/Helpers';

const CalenderPro = (props) => {
  const { schedulingDetails, selectedDay, handleDayClick, calenderLabel } = props;
  let selectedDate = null;

  const disabledDays = schedulingDetails?.apptUnavailableDays?.length
    ? schedulingDetails.apptUnavailableDays.map((dateString) => getFormattedDate(dateString))
    : [];

  let startDate;
  if (schedulingDetails?.apptUnavailableDays?.length && schedulingDetails.apptUnavailableDays.includes(schedulingDetails.startDate)) {
    startDate = schedulingDetails.apptAvailableDays[0].date;
  } else {
    startDate = schedulingDetails?.startDate;
  }
  const defaultDate =
    schedulingDetails.apptAvailableDays && schedulingDetails.apptAvailableDays.length > 0 && schedulingDetails.apptAvailableDays[0].date;
  if (selectedDay === null) {
    if (props?.currentPageName === 'deviceSetup') {
      selectedDate = null;
    } else {
      selectedDate = new Date(getFormattedDate(defaultDate));
    }
  } else {
    selectedDate = selectedDay;
  }
  return (
    <DatePicker
      disabled={false}
      selectedDate={selectedDate}
      minDate={new Date(getFormattedDate(startDate))}
      maxDate={new Date(getFormattedDate(schedulingDetails.endDate))}
      inactiveDates={disabledDays}
      onChange={handleDayClick}
      width={isMobile() ? '100%' : '398px'}
      label={calenderLabel}
      dateFormat="MM/DD/YYYY"
      errorText="Please select a date"
    />
  );
};

CalenderPro.propTypes = {
  handleDayClick: PropTypes.func,
  schedulingDetails: PropTypes.object,
  selectedDay: PropTypes.object,
  calenderLabel: PropTypes.string,
  currentPageName: PropTypes.string,
};

export default CalenderPro;
